export const contactConstants = {
    GET_ALL_REQUEST: "CONTACT_GET_ALL_REQUEST",
    GET_ALL_SUCCESS: "CONTACT_GET_ALL_SUCCESS",
    GET_ALL_FAILURE: "CONTACT_GET_ALL_FAILURE",
};
